import React, { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import DriverTable from "./DriverTable";
import RiderTable from "./RiderTable";
import NotificationPopup from "./NotificationPopup";
import { EditorProvider } from "react-simple-wysiwyg";
import { User } from "../../types/users";

const UserManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    setSelectedUsers([]);
  };

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer" sx={{ flexDirection: "column" }}>
        <TopBar />
        <Box sx={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <Box
            sx={{
              position: "sticky",
              top: "64px",
              zIndex: 9,
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: "4px",
              marginBottom: "4px",
            }}
          >
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="Drivers" />
              <Tab label="Riders" />
            </Tabs>
            <EditorProvider>
              <NotificationPopup
                disabled={selectedUsers.length === 0}
                selectedUsers={selectedUsers}
              />
            </EditorProvider>
          </Box>
          <Paper elevation={3} sx={{ padding: "20px" }}>
            {activeTab === 0 && <DriverTable onSelectionChange={setSelectedUsers} />}
            {activeTab === 1 && <RiderTable onSelectionChange={setSelectedUsers} />}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default UserManagement;
